export const CONSTITUTIONS = [
  "individual",
  "proprietorship",
  "partnership",
  "llp",
  "private_limited",
  "public_limited",
  "huf",
  "trust",
  "society",
  "other",
];

export const SERVICES = [
  "GST",
  "Income Tax",
  "ROC",
  "TDS",
  "Tax Audit",
  "Statutory Audit",
  "Audit",
  "Advisory",
  "Payroll",
  "Others",
];

export const EDITABLE_CLIENT_FIELDS = [
  "name",
  "constitution",
  "pan",
  "gstin",
  "email",
  "phone",
  "mobile",
  "address",
  "city",
  "state",
  "pincode",
];

export const IDENTITY_FIELDS = ["pan", "gstin"];

export const CLIENT_FIELD_MAX = {
  client_code: 64,
  name: 255,
  pan: 16,
  gstin: 32,
  email: 255,
  phone: 32,
  mobile: 32,
  address: 512,
  city: 128,
  state: 128,
  pincode: 16,
};

export const clientToForm = (client) => ({
  ...Object.fromEntries(
    EDITABLE_CLIENT_FIELDS.map((f) => [f, client?.[f] ?? ""]),
  ),
  constitution: client?.constitution || "individual",
  services_availed: client?.services_availed || [],
});
